import { render } from "./QuestionThreeView.vue?vue&type=template&id=532b39dc&scoped=true&ts=true"
import script from "./QuestionThreeView.vue?vue&type=script&lang=ts"
export * from "./QuestionThreeView.vue?vue&type=script&lang=ts"

import "./QuestionThreeView.vue?vue&type=style&index=0&id=532b39dc&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532b39dc"]])

export default __exports__